var text_field_default = {
  "root": "re83L",
  "text": "mImQx",
  "input": "E-1yA",
  "small": "sYN6-",
  "medium": "T8Frq",
  "large": "ylBi0",
  "webview": "defSz",
  "endAdornment": "zs-wg",
  "shown": "PwcDh",
  "value": "S1BXA",
  "spinner": "sufNN",
  "spin": "bYTTE"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
